import { FC, SVGProps } from 'react'

interface CloseOutlinedIconProps extends SVGProps<SVGSVGElement> {
  size?: number
  color?: string
}

export const CloseOutlinedIcon: FC<CloseOutlinedIconProps> = ({
  size = 24,
  color = 'white',
  strokeWidth = 1.5,
  ...props
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M17 7L7 17"
        stroke={color}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7 7L17 17"
        stroke={color}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
